<template>
	<div
		v-show="load"
		:class="[$style.env, $style[env], envClass]"
	>
		<span v-if="env === 'production'">
			<span class="font-weight-800">Entorno:</span> Producción
		</span>
		<span
			v-else
			class="d-flex justify-content-between w-100 text-nowrap d-block"
		>
			<span class="text-truncate"><b>Entorno:</b> Desarrollo</span>
			<span class="text-truncate">{{ $app.paths.api_dev }}</span>
		</span>
	</div>
</template>

<script>
export default {
	name: 'EnvBar',
	data() {
		return {
			load: true
		};
	},
	computed: {
		env() {
			return this.$settings.env;
		},
		envClass() {
			let className = 'animate__animated animate__faster';
			if (this.$settings.env !== 'production') {
				className += ' animate__fadeInUp animate__delay-2s';
			} else {
				className += ' animate__fadeOutDown animate__delay-s';
			}
			return className;
		}
	},
	watch: {
		env(val) {
			if (val !== 'production') {
				this.load = true;
			}
		}
	},
	created() {
		if (this.env === 'production') {
			this.load = false;
		} else {
			this.load = true;
		}
	}
};
</script>

<style lang="scss" module>
.env {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 30px;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	color: white;
	align-items: center;
	padding: 0 10px;
	text-transform: uppercase;
	font-weight: bold;
	justify-content: flex-end;
	z-index: 99;

	img {
		max-height: 60px;
		margin-top: -40px;
	}
}

.env.production {
	background: $primary;
}

.env.development {
	background: $yellow;
	color: darken($yellow, 35%);
}

@media (max-width: $sm-min-width) {
	.env {
		justify-content: center;
	}
}
</style>
